import React, { ChangeEvent } from 'react';
import { AvailableTimeOption } from './reservationForm.utils.ts';

export type FloorOption = {
  id: string | number;
  name: string;
};

export type ReservationFormScheduleFieldsProps = {
  isEditing: boolean;
  date: Date;
  maxDateValue?: string;
  onDateChange: (e: ChangeEvent<HTMLInputElement>) => void;
  salaId: string;
  floors: FloorOption[];
  onSalaChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  availableTimeOptions: AvailableTimeOption[];
  selectedTimeValue: string;
  loadingShifts: boolean;
  onTimeChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  blockedShiftNotice: string;
  noAvailableShiftsMessage: string;
};

export default function ReservationFormScheduleFields({
  isEditing,
  date,
  maxDateValue,
  onDateChange,
  salaId,
  floors,
  onSalaChange,
  availableTimeOptions,
  selectedTimeValue,
  loadingShifts,
  onTimeChange,
  blockedShiftNotice,
  noAvailableShiftsMessage,
}: ReservationFormScheduleFieldsProps) {
  return (
    <>
      <div className="form-group">
        <label htmlFor="date">Data</label>
        <input
          id="date"
          name="date"
          type="date"
          lang="pt-BR"
          value={date.toLocaleDateString('en-CA')}
          onChange={onDateChange}
          max={isEditing ? undefined : maxDateValue}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="sala_id">Sala</label>
        <select
          id="sala_id"
          name="sala_id"
          value={salaId}
          onChange={onSalaChange}
          required
        >
          <option value="">Selecione uma sala</option>
          {floors.map((floor) => (
            <option key={floor.id} value={floor.id}>
              {floor.name}
            </option>
          ))}
        </select>
      </div>

      {salaId && availableTimeOptions.length > 0 && (
        <div className="form-group">
          <label htmlFor="time">
            Horário {loadingShifts && <span>(Carregando...)</span>}
          </label>
          <select
            id="time"
            name="time"
            value={selectedTimeValue}
            onChange={onTimeChange}
            required
            disabled={loadingShifts}
          >
            <option value="">Selecione um horário</option>
            {availableTimeOptions.map((option) => (
              <option key={option.key} value={option.value} disabled={option.isBlocked}>
                {option.isBlocked ? `${option.label} (bloqueado)` : option.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {salaId && blockedShiftNotice && (
        <div className="form-group full-width">
          <span className="table-availability-message warning">{blockedShiftNotice}</span>
        </div>
      )}

      {salaId && !loadingShifts && availableTimeOptions.length === 0 && (
        <div className="form-group full-width">
          <label>Horários disponíveis</label>
          <span className="table-availability-message error">
            {noAvailableShiftsMessage || 'Não existem horários disponíveis para esta data.'}
          </span>
        </div>
      )}
    </>
  );
}
